import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UseIcon from "@mui/icons-material/TouchApp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { convertHtmlToPdf } from "../lib/convertToPdf";
import { PosterResponse, TemplateResponse } from "../pagesNew/interfaces";
import checkPermission from "./permissions";
import { useDcpAuth } from "../../../../contexts/DcpAuthContext";
import { useDcpApi, availablePaths } from "../../../../services/DcpService";

interface PosterProps {
  poster: PosterResponse | TemplateResponse;
  isDownloadPage?: boolean;
  currentPoster?: PosterResponse[];
  setCurrentPoster?: Function;
  layout: string;
}

const PosterCard: React.FC<PosterProps> = ({
  poster,
  isDownloadPage,
  currentPoster,
  setCurrentPoster,
  layout,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [newTitle, setNewTitle] = useState(poster.title);
  // const [imageUrl, setImageUrl] = useState<string>("");
  const navigate = useNavigate();
  const { dcpApi, dcpResponse, dcpIsLoading, dcpError } = useDcpApi();
  const {
    dcpApi: deleteApi,
    dcpResponse: deleteResponse,
    dcpIsLoading: deleteIsLoading,
    dcpError: deleteError,
  } = useDcpApi();
  const { role, isAuthenticated, authIsLoading } = useDcpAuth();

  const { t } = useTranslation("PosterCardPage");

  // useEffect(() => {
  //   const fetchUserInfo = async () => {
  //     await dcpApi(availablePaths.users.getUserById(poster.metadata.author), "GET");
  //   }

  //   if (isAuthenticated) {
  //     fetchUserInfo();
  //   }
  // }, [isAuthenticated]);

  // useEffect(() => {
  //   if (dcpResponse) {
  //     if (!dcpResponse.error) {
  //       setImageUrl(dcpResponse.data.picture);
  //     } else {
  //       console.error("Failed to fetch user info");
  //     }
  //   }
  // }, [dcpResponse])

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // edit
  const handleEditDialog = () => {
    let data = [];
    if (poster.body) data = poster.body.data;
    navigate("/poster/edit/poster/" + poster.id);
    handleClose();
  };

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewTitle(event.target.value);
  };

  // delete

  const handleDeleteDialog = () => {
    setDeleteDialogOpen(true);
    handleClose();
  };

  const handleDeleteClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteSubmit = async () => {
    await deleteApi(
      availablePaths.posterApi.deletePoster(poster.location.content_id),
      "GET"
    );
  };

  useEffect(() => {
    if (deleteResponse) {
      const cp = currentPoster!.filter(
        (posterr) => posterr.location.content_id !== poster.location.content_id
      );

      setCurrentPoster!(cp);
      // Perform any actions after successful update
      toast.success(t("Deleted successfully"));
      handleDeleteClose();
      // Optionally refresh the data or use local state management to update the UI
    }
  }, [deleteResponse]);

  useEffect(() => {
    if (deleteError) {
      console.error("Failed to update:", deleteError);
      toast.error(t("There was an error deleting the poster"));
    }
  }, [deleteError]);

  return (
    <div
      className={
        layout === "card"
          ? "rounded overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 ease-in-out"
          : "flex rounded overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 ease-in-out items-center"
      }
    >
      <img
        src={
          (poster as PosterResponse).preview
            ? availablePaths.imageUpload.getImageByPrefix(
                (poster as PosterResponse).preview
              )
            : "https://cdn.pixabay.com/photo/2024/02/24/20/54/books-8594725_1280.jpg"
        }
        alt="cover_image"
        className={
          layout === "card"
            ? "w-full h-64 object-cover object-top"
            : "w-64 h-48 object-cover object-top"
        }
      />
      <div className="p-4 flex-grow">
        <h2 className="text-slate-700 font-bold text-xl">{poster.title}</h2>
        <div
          className={
            layout === "card"
              ? "text-slate-600 flex justify-between mt-3"
              : "text-slate-600 flex flex-col mt-3"
          }
        >
          <div
            className={
              layout === "card" ? "flex items-center" : "flex items-center mr-3"
            }
          >
            {/* {imageUrl.length > 0 ? (
              <img
                src={availablePaths.imageUpload.getImageByPrefix(imageUrl)}
                className=" h-7 w-7 rounded-full"
              />
            ) : ( */}
            <PersonIcon />
            {/* )} */}
            <span className="ml-1">
              {t("By")} - {poster.metadata.author_name}
            </span>
          </div>
          <div className="flex items-center">
            <DateRangeIcon />
            <span className="ml-1">
              {new Date(poster.metadata.modified).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
      <div
        className={
          layout === "card"
            ? "px-4 pb-4 flex justify-end items-center"
            : "flex justify-end items-center pr-4"
        }
      >
        {isDownloadPage ? (
          <>
            {" "}
            {checkPermission(role, "download", "download") && (
              <button
                onClick={() => convertHtmlToPdf(poster.body, poster.title)}
                className="flex items-center text-sm font-bold"
              >
                <DownloadForOfflineIcon />
                <span className="ml-1">{t("Download")}</span>
              </button>
            )}{" "}
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              {checkPermission(role, "download", "edit") && (
                <MenuItem onClick={handleEditDialog}>
                  <EditIcon />
                  <span className="ml-1 ring-offset-neutral-600">
                    {t("Edit")}
                  </span>
                </MenuItem>
              )}{" "}
              {checkPermission(role, "download", "delete") && (
                <MenuItem onClick={handleDeleteDialog}>
                  <DeleteIcon />
                  <span className="ml-1">{t("Delete")}</span>
                </MenuItem>
              )}
            </Menu>
          </>
        ) : (
          <>
            {checkPermission(role, "poster", "edit") && (
              <button
                onClick={handleEditDialog}
                className="flex items-center text-sm font-bold"
              >
                <EditIcon />
                <span className="ml-1">{t("Edit")}</span>
              </button>
            )}
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              {" "}
              {checkPermission(role, "poster", "download") && (
                <MenuItem
                  onClick={() => convertHtmlToPdf(poster.body, poster.title)}
                >
                  <DownloadForOfflineIcon />
                  <span className="ml-1">{t("Download")}</span>
                </MenuItem>
              )}
              {checkPermission(role, "poster", "delete") && (
                <MenuItem onClick={handleDeleteDialog}>
                  <DeleteIcon />
                  <span className="ml-1">{t("Delete")}</span>
                </MenuItem>
              )}
            </Menu>
          </>
        )}
      </div>

      {/* delete dialog  */}
      <Dialog open={deleteDialogOpen} onClose={handleDeleteClose}>
        <DialogTitle>
          {t("Do you want to delete")} {poster.title} ?
        </DialogTitle>

        <DialogActions>
          <Button onClick={handleDeleteClose}>{t("Cancel")}</Button>
          <Button onClick={handleDeleteSubmit}>{t("Delete")}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PosterCard;
